module.exports = __webpack_public_path__ + "img/benefits.c12c7246.svg";